module.exports = __webpack_public_path__ + "static/media/02_02.ed844379.png";